export default [
  {
    index: 1,
    label: "Putting the Principles into Practice",
    description:
      "Sharing personal practices, experiences, and challenges in applying the Rosicrucian teachings to daily life.",
  },
  {
    index: 2,
    label: "Mystical Insights",
    description:
      "Reflections, questions, and discussions inspired by the teachings.",
  },
  {
    index: 3,
    label: "Science and Mysticism",
    description:
      "Exploring intersections between Rosicrucian philosophy and modern science.",
  },
  {
    index: 4,
    label: "Service and Community",
    description:
      "Discussions on service within the affiliated bodies and other ways of embodying the Law of AMRA.",
  },
  {
    index: 5,
    label: "Symbolism and Ritual",
    description:
      "Discussions on symbolism, sacred geometry, and the deeper meaning behind Rosicrucian ceremonies and rituals.",
  },
  {
    index: 6,
    label: "The Rosicrucian Tradition",
    description:
      "Exploring Rosicrucian history and the great mystics of the past.",
  },
];
